import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  RestaurantRawMaterialCategoryDTO,
  RestaurantRawMaterialCategoryForm,
  RestaurantRawMaterialCategoryPage,
} from '../../../types/restaurant/RestaurantRawMaterialCategoryTypes';

export const emptyRawMaterialCategoryForm: RestaurantRawMaterialCategoryForm = {
  name: '',
  description: '',
  icon: '',
  color: '#10B981',
  displayOrder: 1,
};

interface State {
  list: RestaurantRawMaterialCategoryDTO[];
  page: RestaurantRawMaterialCategoryPage | null;
  form: RestaurantRawMaterialCategoryForm;
  loading: boolean;
  saving: boolean;
  modalOpen: boolean;
}

const initialState: State = {
  list: [],
  page: null,
  form: emptyRawMaterialCategoryForm,
  loading: false,
  saving: false,
  modalOpen: false,
};

const slice = createSlice({
  name: 'restaurantRawMaterialCategory',
  initialState,
  reducers: {
    setRawMaterialCategoryPage: (
      state,
      action: PayloadAction<RestaurantRawMaterialCategoryPage | null>
    ) => {
      state.page = action.payload;
      state.list = action.payload?.content ?? [];
    },
    setRawMaterialCategoryLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setRawMaterialCategorySaving: (state, action: PayloadAction<boolean>) => {
      state.saving = action.payload;
    },
    openRawMaterialCategoryCreate: (state) => {
      state.form = { ...emptyRawMaterialCategoryForm };
      state.modalOpen = true;
    },
    openRawMaterialCategoryEdit: (
      state,
      action: PayloadAction<RestaurantRawMaterialCategoryDTO>
    ) => {
      const item = action.payload;
      state.form = {
        id: item.id,
        code: item.code,
        name: item.name,
        description: item.description ?? '',
        icon: item.icon ?? '',
        color: item.color ?? '#10B981',
        displayOrder: item.displayOrder,
        active: item.active,
      };
      state.modalOpen = true;
    },
    closeRawMaterialCategory: (state) => {
      state.form = { ...emptyRawMaterialCategoryForm };
      state.modalOpen = false;
    },
    updateRawMaterialCategoryField: (
      state,
      action: PayloadAction<{
        field: keyof RestaurantRawMaterialCategoryForm;
        value: RestaurantRawMaterialCategoryForm[keyof RestaurantRawMaterialCategoryForm];
      }>
    ) => {
      state.form = {
        ...state.form,
        [action.payload.field]: action.payload.value,
      };
    },
  },
});

export const {
  setRawMaterialCategoryPage,
  setRawMaterialCategoryLoading,
  setRawMaterialCategorySaving,
  openRawMaterialCategoryCreate,
  openRawMaterialCategoryEdit,
  closeRawMaterialCategory,
  updateRawMaterialCategoryField,
} = slice.actions;
export default slice.reducer;
